import React from 'react';
import { useSelector } from 'react-redux';

import { Divider } from 'antd';

import { RibbonBar, RibbonDivider } from 'common/components';
import MaintenanceInfoSection from './components/sections/member-maintenance-grid/MaintenanceInfoSection';
import MemberCommunicateSection from './components/sections/member-maintenance-grid/MemberCommunicateSection';
import MemberEditSection from './components/sections/member-maintenance-grid/MemberEditSection';
import MemberExportSection from './components/sections/member-maintenance-grid/MemberExportSection';
import UserActionsSection from './components/sections/user-maintenance-grid/UserActionsSection';
import MemberTemplateSection from './components/sections/member-maintenance-grid/MemberTemplateSection';
import OpenMemberSection from './components/sections/member-maintenance-grid/OpenMemberSection';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import DetailSection from './components/sections/home-grid/DetailSection';
import MemberEditRoleSecuritySection from './components/sections/member-maintenance-grid/MemberEditRoleSecuritySection';
// import OpenTicketGroupMember from './components/sections/member-maintenance-grid/OpenTicketGroupMember';
import MemberActions from './components/sections/member-maintenance-grid/member-action';
import UserReactive from './components/controls/maintenance/user/UserReactive';
import { ViewLayout, AdvanceStack } from './components';

import * as memberMaintenanceSelectors from 'pages/member-maintenance/controllers/selectors';

import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

const MemberMaintenanceGridView = () => {
  const isMemberGridInfoView = useSelector(
    memberMaintenanceSelectors.selectIsMemberGridInfoView()
  );

  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection disabled={!isMemberGridInfoView} />
      <ViewLayout disabled />
      <RibbonDivider />
      <MaintenanceInfoSection />
      <RibbonDivider />
      <MemberTemplateSection />
      <RibbonDivider />
      <MemberExportSection />
      <RibbonDivider />
      <MemberCommunicateSection isMemberGridInfoView={isMemberGridInfoView} />
      <RibbonDivider />

      {isMemberGridInfoView && (
        <>
          <MemberEditRoleSecuritySection />
          <RibbonDivider />
          <MemberActions />
          {/* <OpenTicketGroupMember />
          <RibbonDivider /> */}
        </>
      )}
      {isMemberGridInfoView && (
        <>
          <Can I={ABILITY_ACTION.VIEW} a={ABILITY_SUBJECT.MANAGE_MEMBER}>
            <RibbonDivider />
            <OpenMemberSection />
          </Can>
          <Can I={ABILITY_ACTION.EDIT} a={ABILITY_SUBJECT.MEMBER}>
            <Divider
              type='vertical'
              style={{ height: 40, margin: '4px 8px' }}
            />
            <MemberEditSection />
          </Can>
        </>
      )}
      <UserReactive />
      {!isMemberGridInfoView && (
        <>
          <RibbonDivider />
          <UserActionsSection />
        </>
      )}

      <AdvanceStack isDisabled />
    </RibbonBar>
  );
};

export default MemberMaintenanceGridView;
